module.exports = __webpack_public_path__ + "static/media/userIcon.ed68a1cf.svg";